export default __webpack_public_path__ + "c7d5c8b91303a4c8454aa1bbbf3f97de.png";